const drawerPaperSx = {
  borderTopLeftRadius: '16px',
  borderTopRightRadius: '16px',
  maxHeight: '70vh',
  overflow: 'hidden',
};

export const drawerPaperProps = { sx: drawerPaperSx };

export const drawerContentSx = {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  pb: '16px',
};

export const handleBarSx = {
  width: '36px',
  height: '4px',
  borderRadius: '2px',
  backgroundColor: ({ palette }) => palette.action.disabled,
  margin: '8px auto 0',
};

export const headerSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 8px 4px 16px',
};

export const titleSx = {};

export const closeButtonSx = {
  color: ({ palette }) => palette.text.secondary,
};

export const sectionHeaderSx = {
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: ({ palette }) => palette.text.secondary,
  padding: '12px 16px 4px',
};

export const actionItemSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
  gap: '12px',
  padding: '8px 16px',
  cursor: 'pointer',
  textAlign: 'left',
  borderLeft: '3px solid transparent',
  '&:hover': {
    backgroundColor: ({ palette }) => palette.action.hover,
  },
  '&:active': {
    backgroundColor: ({ palette }) => palette.action.selected,
  },
};

export const disabledActionItemSx = {
  ...actionItemSx,
  opacity: 0.4,
  cursor: 'default',
  '&:hover': {},
  '&:active': {},
};

export const iconWrapperSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '8px',
  flexShrink: 0,
  fontSize: '1.25rem',
};

export const defaultIconWrapperSx = {
  ...iconWrapperSx,
  backgroundColor: ({ palette }) => palette.action.hover,
  color: ({ palette }) => palette.text.secondary,
};

export const actionNameSx = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const rowDividerSx = {
  marginLeft: '60px',
};

export const groupDividerSx = {
  margin: '4px 16px',
};

export const confirmationContainerSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '24px 16px',
  gap: '16px',
};

export const confirmationIconSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '48px',
  height: '48px',
  borderRadius: '12px',
  fontSize: '1.75rem',
};

export const confirmationDefaultIconSx = {
  ...confirmationIconSx,
  backgroundColor: ({ palette }) => palette.action.hover,
  color: ({ palette }) => palette.text.secondary,
};

export const confirmationActionNameSx = {
  textAlign: 'center',
};

export const confirmationButtonsSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
  padding: '0 8px',
};

export const cancelButtonSx = {
  backgroundColor: '#f0f0f0',
  color: ({ palette }) => palette.text.primary,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#e0e0e0',
    boxShadow: 'none',
  },
};
